import CloseIcon from '@mui/icons-material/Close';
import SendIcon from '@mui/icons-material/Send';
import { DialogActions, DialogContent, DialogTitle } from '@mui/material';
import React, { useEffect, useState } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import { useTranslation } from 'react-i18next';
import { ControlpanelPrimaryButton, ControlpanelSecondaryButton, GrayIconButton } from '../../../components/StyledButton';
import { CustomDialog } from '../../../components/StyledComponents';

const VerifyYourEmailDialog = ({ onClose }) => {
   const { t } = useTranslation();

   const [capValue, setCapValue] = useState(null);
   const [isValid, setIsValid] = useState(false);

   useEffect(() => {
      if (capValue !== null) {
         setIsValid(true);
      } else {
         setIsValid(false);
      }
   }, [capValue]);

   return (
      <CustomDialog maxWidth={'xl'} open keepMounted onClose={onClose}>
         <DialogTitle>
            <div className='flex justify-between'>
               <div className='flex items-center gap-4'>
                  <p className='text-xl font-semibold '>{t('navbar.verify-your-email.title')}</p>
               </div>
               <GrayIconButton onClick={onClose}>
                  <CloseIcon />
               </GrayIconButton>
            </div>
         </DialogTitle>

         <DialogContent>
            <p>
               {t('navbar.verify-your-email.you-have-signed-up-using')} phamxuankhanh@mobile-id.vn{' '}
               {t('navbar.verify-your-email.and-it-needs-to-be-verified')}
            </p>
            <p className='mt-3'>{t('navbar.verify-your-email.did-not-receive-email-resend-it')}</p>
            <div className='mt-3'>
               <ReCAPTCHA sitekey='6LcgWYQpAAAAANNFmUEodndRRBpcmRaVzXJhONJd' onChange={(val) => setCapValue(val)} />
            </div>
            <div className='mt-3'>
               <ControlpanelPrimaryButton disabled={!isValid}>
                  <SendIcon />
                  <p>{t('button.resend-email')}</p>
               </ControlpanelPrimaryButton>
            </div>
         </DialogContent>
         <DialogActions>
            <div className='flex gap-2 px-4 py-4'>
               <ControlpanelSecondaryButton onClick={onClose}>
                  <CloseIcon />
                  <p>{t('button.close')}</p>
               </ControlpanelSecondaryButton>
            </div>
         </DialogActions>
      </CustomDialog>
   );
};

export default VerifyYourEmailDialog;
